export default {
  hasApiModule: (state) => (id) =>
    state.apiModules.some(({ alias }) => alias === id),
  hasApiModulePfdod: (state, getters) => getters.hasApiModule('pfdod'),
  hasApiModuleConsultations: (state, getters) => getters.hasApiModule('consultations'),
  hasSferumModule: (state, getters) => getters.hasApiModule('sferum'),
  hasApiModuleIntalent: (state, getters) => getters.hasApiModule('intalent'),
  hasApiModuleDnevnikRu: (state, getters) => getters.hasApiModule('dnevnikRu'),
  hasApiModulesNoko: (state, getters) => getters.hasApiModule('noko'),
  hasApiModuleOrganizations: (state, getters) =>
    getters.hasApiModule('organizations'),
  hasApiModuleSubordination: (state, getters) =>
    getters.hasApiModule('subordination'),
  hasApiModuleGuru: (state, getters) => getters.hasApiModule('guru'),
  hasApiModuleEsia: (state, getters) => getters.hasApiModule('esia'),
  hasApiModuleBlogReviews: (state, getters) =>
    getters.hasApiModule('blogReviews'),
  hasApiModuleRegionsZoning: (state, getters) =>
    getters.hasApiModule('regionsZoning'),
  hasApiModuleМunicipality: (state, getters) =>
    getters.hasApiModule('municipality'),
  hasApiModuleRemoteEdu: (state, getters) => getters.hasApiModule('remote-edu'),
  hasApiModuleVacancies: (state, getters) => getters.hasApiModule('vacancies'),
  hasApiModuleVacanciesOrders: (state, getters) => getters.hasApiModule('vacancyOrders'),
  dadataToken: (state, getters) => {
    const token = state.apiModules.find(({ alias }) => alias === 'dadata');
    return token.key;
  },
  hasApiModulePortfolio: (state, getters) => getters.hasApiModule('portfolio'),
};



// WEBPACK FOOTER //
// ./src/store/getters.js